<template>
  <el-row :gutter="4" style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;background-color: blue;height: 50px">
    <el-col :span="4"></el-col>
    <el-col :span="14" style="text-align: center;">
      <div style="font-size: 30px;color: white;">
        考试成绩
      </div>
    </el-col>
    <el-col :span="6">
      <el-menu mode="horizontal">
        <el-sub-menu index="1">
          <template #title>
            <div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
          </template>
          <el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
          <el-menu-item v-if="!isBuy" @click="handleToPath('/fire/try/practice/theoryMediumDevice','try', 'practice')" index="home">理论练习</el-menu-item>
          <el-menu-item v-if="!isBuy" @click="handleToPath('/fire/try/exam/theoryMediumDevice','try', 'exam')" index="home">模拟考试</el-menu-item>
          <el-menu-item v-if="!isBuy" @click="handleToPath('/fire/normal/practice/peopleMediumDevice','normal', 'practice')" index="home">操作练习</el-menu-item>
          <el-menu-item v-if="!isBuy" @click="handleToPath('/fire/try/exam/theoryMediumDevice','try', 'exam')" index="home">模拟线下考试</el-menu-item>
          <el-menu-item v-if="isBuy" @click="handleToPath('/fire/normal/practice/theoryMediumDevice','normal', 'practice')" index="home">理论练习</el-menu-item>
          <el-menu-item v-if="isBuy" @click="handleToPath('/fire/normal/exam/theoryMediumDevice','normal', 'exam')" index="home">模拟考试</el-menu-item>
          <el-menu-item v-if="isBuy" @click="handleToPath('/fire/normal/practice/peopleMediumDevice','normal', 'practice')" index="home">操作练习</el-menu-item>
          <el-menu-item v-if="isBuy" @click="handleToPath('/fire/try/exam/peopleMediumDevice','normal', 'exam')" index="home">模拟线下考试</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-col>
  </el-row>
  <transition name="fade">
    <div v-if="isLoading" class="loading-screen">
      <div class="loading-icon"></div>
    </div>
    <div v-else>
      <el-row>
        <el-col :span="4">

        </el-col>
        <el-col :span="16">
          <el-table :data="examScore.examAnswerInfoDtoList" title="详细得分">
            <el-table-column prop="typeName" label="科目类型" width="180">
            </el-table-column>
            <el-table-column prop="correctCount" label="正确题数">
            </el-table-column>
            <el-table-column prop="errorCount" label="错误题数">
            </el-table-column>
            <el-table-column prop="score" label="得分">
            </el-table-column>
          </el-table>
            <div style="float: right">总分合计{{ examScore.totalScore }}</div>
          <div v-if="examScore.passed" style="color: green;font-size: 30px">考试通过</div>
          <div v-else style="color: red;font-size: 30px">考试未通过</div>
          <div style="margin-top: 20px">
            <el-button type="warning" v-if="examScore.totalErrorCount>0" style="float:right;margin-right: 20px" @click="getErrorQuestion()">练习本次错题</el-button>
            <el-button type="success" v-if="paperStatus==='randomExam'" style="float:right;margin-right: 20px" @click="getNewExam">继续考试</el-button>
            <el-button type="primary" style="float:right;margin-right: 20px" v-if="!isBuy&&examType==='theory'" @click="handleToPath('/fire/try/exam/theoryMediumDevice','try', 'exam')">返回</el-button>
            <el-button type="primary" style="float:right;margin-right: 20px" v-if="!isBuy&&examType==='people'" @click="handleToPath('/fire/try/exam/peopleMediumDevice','try', 'exam')">返回</el-button>
            <el-button type="primary" style="float:right;margin-right: 20px" v-if="isBuy&&examType==='theory'" @click="handleToPath('/fire/normal/exam/theoryMediumDevice','normal', 'exam')">返回</el-button>
            <el-button type="primary" style="float:right;margin-right: 20px" v-if="isBuy&&examType==='people'" @click="handleToPath('/fire/normal/exam/peopleMediumDevice','normal', 'exam')">返回</el-button>
          </div>
        </el-col>

        <el-col :span="4">

        </el-col>
      </el-row>
    </div>
  </transition>
</template>

<script>
import {useRoute} from "vue-router/dist/vue-router";
import {ref} from "vue";
import request from "@/utils/request";
import router from "@/router";
import {ElMessage} from "element-plus";

const examId = ref('');


const loginUserId = localStorage.getItem("loginUserId");
const loginNickName = localStorage.getItem("loginNickName");
const examScore = ref({});


const isBuy=ref(false);
const areaId=ref('');
const examType=ref('');
const paperId=ref('');
const paperStatus=ref('');
const subjectId=ref('');

function getUserAuthorization(paperId) {
  request.get('/userAuthorization/check',
      {params:{
          userId: loginUserId, paperId:paperId, type:"subject"
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          isBuy.value=result.data.checked;
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getExamInfos(examId, examType) {
  request.get('/examInfo/getExamInfo',
      {
        params: {
          "userId": loginUserId,
          "examId": examId,
          "examType": examType
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          examScore.value = result.data;
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

export default {
  name: "ExamScore",
  created() {
    setTimeout(() => {
      this.isLoading = false
    }, 2000)
    const route = useRoute();
    examId.value = route.query.examId;
    areaId.value=route.query.areaId;
    paperId.value=route.query.paperId;
    examType.value=route.query.examType;
    paperStatus.value=route.query.paperStatus;
    subjectId.value=route.query.subjectId;
    this.getUserAuthorization(paperId.value);
    getExamInfos(examId.value, examType.value);

  },
  data() {
    return {
      examId: examId,
      isLoading: true,
      examScore: examScore,
      loginNickName: loginNickName,
      isBuy:isBuy,
      areaId:areaId,
      examType:examType,
      paperId:paperId,
      subjectId:subjectId,
      paperStatus:paperStatus
    }
  },
  methods: {
    handleToPage(path) {
      router.push(path);
    },

    handleToPath(path,buyMode,studyMode){
      router.push({path:path,query:{areaId: areaId.value, studyMode: studyMode, buyMode:buyMode, subjectType:examType.value}});
    },

    getUserAuthorization(paperId){
      getUserAuthorization.call(this,paperId)
    },
    getErrorQuestion(){
      if(examType.value==="theory"){
        router.push({path:'/fire/TheoryPaperPractice',query:{examId: examId.value, questionNumber:1, paperId:paperId.value, areaId:areaId.value}});
      }
      if(examType.value==="people"){
        router.push({path:'/fire/PeoplePaperPractice',query:{examId: examId.value, questionNumber:1, paperId:paperId.value, areaId:areaId.value}});
      }
    },
    getNewExam(){
      if(examType.value==="theory"){
        router.push({path:'/fire/TheoryPaperExam',query:{areaId:areaId.value, paperId:paperId.value, paperStatus:paperStatus.value, subjectId:subjectId.value}});
      }
      if(examType.value==="people"){
        router.push({path:'/fire/PeoplePaperExam',query:{areaId:areaId.value, paperId:paperId.value, paperStatus:paperStatus.value, subjectId:subjectId.value}});
      }
    }
  }

}
</script>

<style scoped>
.mode-col {
  height: 300px;
  width: 400px; /* 设置一个高度让背景显示出来 */
  background-size: contain;
  background-repeat: no-repeat; /* 背景图片覆盖整个元素 */
  transition: background-image 0.5s; /* 可选的，背景图变化过渡效果 */
  align-content: center;
  /*background-color: lightgray;*/
}

.el-menu {
  background-color: transparent;
  border-bottom-color: transparent;
}

.el-menu-item {
  background-color: transparent !important;
  color: black !important;
  font-weight: 50;
  width: 200px;
  font-size: 18px;
  text-align: center;
&:not(.is-disabled):hover {
   color: gray !important;
   background-color: lightgray !important;
   width: 200px;
   text-align: center;
 }
}
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  transition: opacity 1s ease-out;
  opacity: 1;
}

.loading-screen.fade-out {
  opacity: 0;
  transition: opacity 1s ease-in;
}

.loading-icon {
  /* 动画CSS样式 */
  width: 50px;
  height: 50px;
  border: 6px solid #ddd;
  border-top-color: skyblue;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: spin 3s linear infinite;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
